import { render, staticRenderFns } from "./BCardActionsContainer.vue?vue&type=template&id=1c53ada1&"
import script from "./BCardActionsContainer.vue?vue&type=script&lang=js&"
export * from "./BCardActionsContainer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports